<template>
    <div class="designeroption" :data-designer-component-id="component_id">
        <h3>{{ title }}</h3>
        <div :class="['stylesoption designer-question-tiled-layout', range_question_columns]">
            <template v-for="range in ranges">
                <div @click.prevent="switch_range(range.id)" :class="['tile', localTarget == range.id ? 'active' : '']"
                     v-if="range.id !== 145">
                    <a href="#!">
                        <h5 class="mt-0">{{ range.name }}</h5>
                        <img :src="thumbURL + 'doortype-' + range.thumbnail + '.jpg'" alt="">
                        <label>{{ range.description }}</label>
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </a>
                </div>
                <div v-else class="tile">
                    <a href="/panel-order-form">
                        <h5 class="mt-0">{{ range.name }}</h5>
                        <img :src="thumbURL + 'doortype-' + range.thumbnail + '.jpg'" alt="">
                        <label>{{ range.description }}</label>
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </a>
                </div>
            </template>
            <div class="tile" v-for="banner in designer_range_section_banners">
                <a :href="banner.link" target="_blank">
                    <img :src="banner.url" class="full-width">
                </a>
            </div>
            <!--flexbox hack-->
            <div class="tile-empty"></div>
            <div class="tile-empty"></div>
            <div class="tile-empty"></div>
        </div>
    </div>
    <div v-show="localTarget == 45" class="designeroption">
        <div class="stylesoption p-6">
            The Inspirations Collection is a range of popular designs taken from the main range with the same quality.
            They are full door sets aimed at being quick and easy with faster lead times. These doors can be ordered
            with satin glass(door only) glass rather than sandblast reducing your cost.
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import DesignerQuestionDoorRange from "../DesignerQuestionDoorRange.vue";

export default {
    mounted() {
        if (this.passed_filter) {
            this.update_options();
        }
    },
    mixins: [
        DesignerQuestionDoorRange,
    ],
    computed: {
        thumbURL() {
            return '/images/hallmark/';
        },
    },
    methods: {
        switch_range(range) {
            window.emitter.emit('new-door', this.defaultdoor[range], this.reference_on);
            window.emitter.emit('range-updated');
        },
    },
}
</script>
